import { useCallback } from 'react';
import {
	useAxiosInstance,
	saveUserSettingQuery,
	CommonSettingKey,
} from '@gov-nx/api';
import {
	useAuthStore,
	useUserStore,
	useUserStoreSearchTerms,
} from '@gov-nx/store';

export const useSearchTermsStorage = () => {
	const activeReza = useAuthStore('activeReza');
	const setUserSettingSearchTerms = useUserStore('setUserSettingSearchTerms');
	const searchTerms = useUserStoreSearchTerms();
	const { axiosInstance } = useAxiosInstance();
	const activeRezaKod = activeReza?.kod ?? '';

	const addSearchTerm = useCallback(
		async (searchTerm: string) => {
			const personTerms = searchTerms.filter(
				(t) => t.rezaKod === activeRezaKod
			);
			const withoutDupes = personTerms.filter(
				(t) => t.searchTerm !== searchTerm
			);
			const updatedForPerson = [
				...withoutDupes,
				{ rezaKod: activeRezaKod, searchTerm },
			];
			const lastTenForPerson = updatedForPerson.slice(-10);
			const otherPersons = searchTerms.filter(
				(t) => t.rezaKod !== activeRezaKod
			);

			const merged = [...otherPersons, ...lastTenForPerson];

			setUserSettingSearchTerms(merged);

			await saveUserSettingQuery(axiosInstance, {
				key: CommonSettingKey.SearchTerms,
				value: merged,
			});

			return merged;
		},
		[searchTerms, setUserSettingSearchTerms, activeRezaKod, axiosInstance]
	);

	const removeSearchTerm = useCallback(
		async (searchTerm: string) => {
			const personTerms = searchTerms.filter(
				(t) => t.rezaKod === activeRezaKod && t.searchTerm !== searchTerm
			);

			const otherPersons = searchTerms.filter(
				(t) => t.rezaKod !== activeRezaKod
			);

			const merged = [...otherPersons, ...personTerms];

			setUserSettingSearchTerms(merged);

			await saveUserSettingQuery(axiosInstance, {
				key: CommonSettingKey.SearchTerms,
				value: merged,
			});

			return merged;
		},
		[searchTerms, setUserSettingSearchTerms, activeRezaKod, axiosInstance]
	);

	const filteredSearchTerms = searchTerms.filter(
		(t) => t.rezaKod === activeRezaKod
	);

	return {
		addSearchTerm,
		searchTerms: filteredSearchTerms,
		removeSearchTerm,
	};
};
